import React, { useMemo, useCallback, useState } from 'react'
import Link from 'react-router-dom/Link'

import apiUtils from '../../../../global/utils/api'

import TextInput from '../../../../global/components/forms/TextInput.js.jsx'
import NumberInput from '../../../../global/components/forms/NumberInput.js.jsx'
import CheckboxInput from '../../../../global/components/forms/CheckboxInput.js.jsx'
import SelectFromObject from '../../../../global/components/forms/SelectFromObject.js.jsx'

const AdminOnboardForm = ({
  cancelLink,
  values,
  handleFormChange,
  handleFormSubmit,
  loading,
}) => {
  const isValid = useMemo(() => {
    if (!values.managedSubscription) {
      return [
        'name',
        'licenseCount',
        'contact_firstName',
        'contact_lastName',
        'contact_email',
        'contact_phone',
      ].every(value => !!value.toString().trim())
    }

    return Object.values(values).every(value => !!value.toString().trim())
  }, [values])

  const [subscriptions, setSubscriptions] = useState([])

  const subscriptionsList = useMemo(() => {
    return subscriptions.map(s => ({
      id: s.subscriptionId,
      display: `${s.subscriptionId} - ${s.status} - ${s.productKey} - ${s.pricingKey}`,
    }))
  }, [subscriptions])

  const onAccounthubIdBlur = useCallback(
    e => {
      handleFormChange({
        target: {
          name: 'subscriptionId',
          value: '',
        },
      })

      apiUtils
        .callAPI(`/api/subscriptions/from-accounthub/${e.target.value}`)
        .then(resp => {
          if (!resp.success) {
            alert(
              'Failed to fetch subscriptions for this customer. Is the AccountHub ID correct?',
            )
            return
          }

          setSubscriptions(resp.subscriptions)
        })
    },
    [setSubscriptions, handleFormChange],
  )

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form
            name="firmForm"
            className="firm-form"
            onSubmit={handleFormSubmit}
          >
            <div className="formHeader">
              <h2>Create Firm</h2>
              <hr />
            </div>
            <TextInput
              change={handleFormChange}
              label="Name"
              name="name"
              placeholder="Name (required - maximum 150 characters)"
              required={true}
              value={values.name}
              minLength="3"
              maxLength="150"
            />
            <NumberInput
              change={handleFormChange}
              firefoxDisplayFix={true}
              min="1"
              label="License count (minimum 1)"
              name="licenseCount"
              required={true}
              step="1"
              value={values.licenseCount}
            />
            <TextInput
              change={handleFormChange}
              label="Owner First Name"
              name="contact_firstName"
              placeholder="First Name (required)"
              required={true}
              value={values.contact_firstName}
              maxLength="150"
            />
            <TextInput
              change={handleFormChange}
              label="Owner Last Name"
              name="contact_lastName"
              placeholder="Last Name (required)"
              required={true}
              value={values.contact_lastName}
              maxLength="150"
            />
            <TextInput
              change={handleFormChange}
              label="Owner Email Address"
              name="contact_email"
              placeholder="Email Address (required)"
              required={true}
              value={values.contact_email}
              maxLength="150"
            />
            <TextInput
              change={handleFormChange}
              label="Owner Phone Number"
              name="contact_phone"
              placeholder="Phone Number (required)"
              required={true}
              value={values.contact_phone}
              maxLength="150"
            />
            <CheckboxInput
              change={handleFormChange}
              label="Billed through partner company"
              name="managedSubscription"
              value={values.managedSubscription}
              helpText="Check this if the firm is provisioned as an Add-on for another subscription (Cosmolex, RocketMatter, etc)"
            />
            {values.managedSubscription ? (
              <React.Fragment>
                <TextInput
                  change={handleFormChange}
                  label="AccountHub (SalesForce) ID"
                  name="accounthubId"
                  placeholder="SalesForce ID (required)"
                  required={true}
                  value={values.accounthubId}
                  maxLength={50}
                  blur={onAccounthubIdBlur}
                />
                <SelectFromObject
                  change={handleFormChange}
                  label="Subscription ID"
                  name="subscriptionId"
                  required={true}
                  selected={values.subscriptionId}
                  value="id"
                  display="display"
                  displayStartCase={false}
                  items={subscriptionsList}
                  placeholder="Select a subscription"
                />
              </React.Fragment>
            ) : null}
            <div className="input-group">
              <div className="yt-row space-between">
                <Link
                  className="yt-btn link"
                  to={cancelLink}
                >
                  Cancel
                </Link>
                <button
                  className="yt-btn"
                  disabled={!isValid || loading}
                  type="submit"
                >
                  {loading ? 'Creating...' : 'Create firm'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AdminOnboardForm
